import { useMutation, useQuery } from '@tanstack/react-query';

import cycleScheduleService from './cycleScheduleService';

import type { CycleSchedule } from '@/types/cycle-evaluation/CycleSchedule';

import { queryClient } from '@/AppWithProviders';
import { CycleEvaluationQueryKey, CycleScheduleQueryKey } from '@/constants/QueryKeys';

const useGetCycleSchedule = ({ cycleEvaluationId }: { cycleEvaluationId: string }) => {
    return useQuery<CycleSchedule>({
        queryKey: [CycleScheduleQueryKey.CYCLE_SCHEDULE, cycleEvaluationId],
        queryFn: () => cycleScheduleService.getCycleSchedule(cycleEvaluationId),
        enabled: !!cycleEvaluationId,
    });
};

const useUpdateCycleSchedule = () => {
    return useMutation({
        mutationFn: (schedule: CycleSchedule) => cycleScheduleService.updateCycleSchedule(schedule),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [CycleEvaluationQueryKey.CYCLE_EVALUATION],
            });
        },
    });
};

export { useGetCycleSchedule, useUpdateCycleSchedule };
